import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import DashboardNavbar from "partials/DashboardNavbar/DashboardNavbar";
import Footer from "partials/Footer/Footer";
import Card from "@mui/material/Card";
import { Link } from "react-router-dom";
import ArchivedOrganizationUsersList from "modules/OrganizationUsersList/ArchivedOrganizationUsersList";

export default function ArchivedUsersPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            p={3}
            lineHeight={1}
            display="flex"
            alignItems="center"
            width="100%"
            justifyContent="space-between"
          >
            <MDTypography variant="h5" fontWeight="medium">
              Archived Users
            </MDTypography>
            <MDTypography as={Link} to="/users">
              <MDButton color="secondary" variant="outlined">
                Back to Users
              </MDButton>
            </MDTypography>
          </MDBox>
          <ArchivedOrganizationUsersList />
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
